<div 
    class="content-element-container"
    [ngClass]="visibilityClass" 
    #hoverContentEl
    (mouseenter)="onMouseEnter(hoverContentEl)"
    (mouseleave)="onMouseOut(hoverContentEl)"
    (click)="onClick(hoverContentEl)"
    [ngStyle]="{'background':''+title?.background+''}">
    <ng-container *ngIf="preview">
        <div class='preview-selected hide'>&nbsp;</div>
    </ng-container>
    <div 
        class="content-element"
        [ngClass]="classes"
        [ngStyle]="{'color':''+title?.color+'','font-family':''+title?.fontFamily+''}"
        kwElementStyler
        [contentEditable]="preview"
        [attr.tabindex]="preview ? 0 : -1"
        (blur)="onBlur($event)"
        (keydown.enter)="onEnterKey($event)"
        [contentElement]="title">
        {{title?.text}}
    </div>
</div>

 <!-- [ngStyle]="{'padding-top':''+contentElement?.paddingTop+'','padding-bottom':''+contentElement?.paddingBottom+'','padding-right':''+contentElement?.paddingRight+'','padding-left':''+contentElement?.paddingLeft+''}" -->



